import React from 'react'
import combineReducer from '../../utils/combineReducers'
import getItemReducer from '../../state/items-detail/get-items-details/reducer'

import {getItems} from '../../state/items-detail/get-items-details/actions'

const AuditDescriptionContext = React.createContext()

function AuditDescriptionContextProvider(props) {
  // [A]
  const [state, dispatch] = React.useReducer(combineReducer({items: getItemReducer}), {items: null})

  const getAll = React.useCallback(data => getItems(data, dispatch), [])
  const value = {
    getAll,
    dispatch,
    ...state,
  }

  // [B]
  return (
    <AuditDescriptionContext.Provider value={value}>
      {props.children}
    </AuditDescriptionContext.Provider>
  )
}

const AuditDescriptionContextConsumer = AuditDescriptionContext.Consumer

export {AuditDescriptionContext, AuditDescriptionContextProvider, AuditDescriptionContextConsumer}
